import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const DataVisualizationWithPowerBI = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="banner">
  <div className="banner-overlay"></div>
  <div className="banner-content">
    <h6 className="banner-subtitle">
      Home / Training / Data Visualization with Power BI and Tableau
    </h6>
    <hr />
    <h1 className="banner-title">
      Data Visualization with Power BI and Tableau Bootcamp
    </h1>
    <p>
      Master Data Visualization. Learn to create dynamic dashboards and insights with Power BI & Tableau!
    </p>
    <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
  </div>
  <img
    src="https://img.freepik.com/free-photo/representation-user-experience-interface-design_23-2150169850.jpg"
    alt="Data Visualization with Power BI and Tableau Banner"
    className="banner-image"
  />
</section>


     <section id="data-viz" className="p_3">
  <div className="container-xl">
    <div className="row about_pg1">
      <div className="col-md-12">
        <div className="about_pg1l mt-5">
          <h6 className="col_yell text-center">Data Visualization with Power BI and Tableau</h6>
          <h2 className="mt-3 mb-3 text-center">
            Master the Art of Data Visualization and Insights
          </h2>
          <p className="text-center">
            Dive into the world of data visualization with Power BI and Tableau.
            This course will teach you how to transform raw data into meaningful
            insights using powerful visualization tools, helping you create
            interactive dashboards and reports.
          </p>
        </div>
      </div>
      {/* <div className="col-md-6">
        <div className="about_pg1r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <a href="#">
                <img
                  src="https://img.freepik.com/free-photo/representation-user-experience-interface-design_23-2150169850.jpg"
                  className="w-100"
                  alt="Data Visualization with Power BI and Tableau"
                />
              </a>
            </figure>
          </div>
        </div>
      </div> */}
    </div>
  </div>
</section>


      <hr />

     <section id="data-visualization" className="p_3">
  <div className="container-xl">
    <div className="row mt-4 pt-5 pb-5 mx-0 px-4">
      <div className="col-md-12">
        <h2 className="mb-4" style={{ color: "black" }}>
          Data Visualization with Power BI & Tableau
        </h2>

        <div className="accordion" id="dataVisualizationAccordion">
          {/* Introduction Section */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Introduction to Data Visualization
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#dataVisualizationAccordion"
            >
              <div className="accordion-body">
                Data visualization is an essential skill in the world of business intelligence. In this course, we focus on two of the most powerful tools—Power BI and Tableau—to help you create meaningful insights from complex data. Learn how to use visualizations to make data-driven decisions.
              </div>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Key Benefits of Power BI & Tableau
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#dataVisualizationAccordion"
            >
              <div className="accordion-body">
                <ul>
                  <li>Gain hands-on experience with Power BI and Tableau.</li>
                  <li>Learn to create dynamic dashboards that offer data-driven insights.</li>
                  <li>Use powerful data visualization tools to transform raw data into actionable intelligence.</li>
                  <li>Enhance your business decision-making with real-time reporting capabilities.</li>
                  <li>Increase your productivity with automation and seamless integrations.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Features of Power BI & Tableau
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#dataVisualizationAccordion"
            >
              <div className="accordion-body">
                <h5>Power BI Features:</h5>
                <ul>
                  <li>Interactive dashboards and reports.</li>
                  <li>Integration with various data sources (Excel, SQL Server, etc.).</li>
                  <li>Powerful data transformations with Power Query.</li>
                  <li>Real-time data monitoring and reporting.</li>
                  <li>Customizable visualizations with pre-built templates.</li>
                </ul>
                <h5>Tableau Features:</h5>
                <ul>
                  <li>Drag-and-drop functionality for quick report creation.</li>
                  <li>Interactive visualizations and dynamic dashboards.</li>
                  <li>Advanced analytics with Tableau Prep for data cleaning.</li>
                  <li>Mobile-friendly dashboards that are accessible anywhere.</li>
                  <li>Integration with a wide range of data connectors.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Learning Path Section */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                Learning Path for Data Visualization
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-bs-parent="#dataVisualizationAccordion"
            >
              <div className="accordion-body">
                <ul>
                  <li>Introduction to Power BI and Tableau Interfaces.</li>
                  <li>Understanding data models and how to import data.</li>
                  <li>Creating simple and complex visualizations with charts and graphs.</li>
                  <li>Building dynamic reports with interactive filters.</li>
                  <li>Sharing and publishing your reports and dashboards.</li>
                  <li>Advanced data analysis techniques (e.g., predictive analytics).</li>
                  <li>Integrating AI and machine learning features into visualizations.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Career Opportunities Section */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFive">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                Career Opportunities in Data Visualization
              </button>
            </h2>
            <div
              id="collapseFive"
              className="accordion-collapse collapse"
              aria-labelledby="headingFive"
              data-bs-parent="#dataVisualizationAccordion"
            >
              <div className="accordion-body">
                Data visualization skills open the door to a variety of career paths, including:
                <ul>
                  <li>Business Intelligence Analyst</li>
                  <li>Data Analyst</li>
                  <li>Data Visualization Specialist</li>
                  <li>Business Analytics Consultant</li>
                 
                </ul>
                These roles are in high demand as businesses increasingly rely on data-driven decision-making. Skilled professionals in data visualization can command competitive salaries and thrive in diverse industries.
              </div>
            </div>
          </div>

          {/* Tools & Resources Section */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSix">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                Tools & Resources for Data Visualization
              </button>
            </h2>
            <div
              id="collapseSix"
              className="accordion-collapse collapse"
              aria-labelledby="headingSix"
              data-bs-parent="#dataVisualizationAccordion"
            >
              <div className="accordion-body">
                <h5>Essential Tools:</h5>
                <ul>
                  <li>Power BI Desktop and Power BI Service</li>
                  <li>Tableau Public and Tableau Server</li>
                  <li>SQL Server, MySQL, or other relational databases</li>
                  <li>Data connectors for Excel, Google Analytics, and APIs</li>
                </ul>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<section id="serv_h" className="p_3">
  <div className="container-xl">
    <div
      className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4"
      style={{ backgroundColor: "black", color: "white" }}
    >
      <div className="col-md-8">
        <div className="serv_h3l">
          <h6 className="">Benefits</h6>
          <h2 className="text-white">
            Master Data Visualization with Power BI & Tableau and enhance your career.
          </h2>
          <p className="text-white mt-3">
            "Join our Data Visualization Bootcamp to gain practical skills in Power BI and Tableau. Learn to create dynamic dashboards, generate business insights, and communicate data findings effectively using these powerful visualization tools."
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Contact Us <span className="arrow">→</span>
            </Link>
          </button>
        </div>
      </div>
      <div className="col-md-4">
        <div className="serv_h3r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <Link to="/contact">
                <img
                  src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                  className="w-100"
                  alt="Data Visualization Bootcamp"
                />
              </Link>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



    </div>
  );
};

export default DataVisualizationWithPowerBI;
